/**
 *
 *
 *
 *
 *
 */
export const onAnimationEnd = (
  element: Element | HTMLElement,
  options: Parameters<HTMLElement["getAnimations"]>[0] = {},
): Promise<PromiseSettledResult<Animation>[]> =>
  Promise.allSettled(element.getAnimations(options).map((animation) => animation.finished));

/**
 *
 *
 *
 *
 *
 */
export const waitForAnimations = (
  elements: Element[],
  options: Parameters<HTMLElement["getAnimations"]>[0] = {},
): Promise<PromiseSettledResult<Animation>[]> =>
  Promise.allSettled(
    elements.flatMap((el) => el.getAnimations?.(options).map((anim) => anim.finished)),
  );
